import { render } from "./Popin.vue?vue&type=template&id=1097dd5f&scoped=true&ts=true"
import script from "./Popin.vue?vue&type=script&lang=ts"
export * from "./Popin.vue?vue&type=script&lang=ts"

import "./Popin.vue?vue&type=style&index=0&id=1097dd5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1097dd5f"]])

export default __exports__